/* Dharohar theme.js — vanilla, no deps, deferred */
(()=>{
'use strict';

const q  = (s,c=document) => c.querySelector(s);
const qa = (s,c=document) => c.querySelectorAll(s);

/* ── MOBILE NAV ────────────────────────────────────────── */
const ham  = q('.hdr__ham');
const nav  = q('.mob-nav');
if(ham && nav){
  const openNav  = () => {
    nav.classList.add('open');
    nav.ariaHidden = 'false';
    ham.ariaExpanded = 'true';
    document.body.style.overflow = 'hidden';
    const first = q('a,button',nav);
    if(first) first.focus();
    document.addEventListener('keydown', navKey);
  };
  const closeNav = () => {
    nav.classList.remove('open');
    nav.ariaHidden = 'true';
    ham.ariaExpanded = 'false';
    document.body.style.overflow = '';
    ham.focus();
    document.removeEventListener('keydown', navKey);
  };
  const navKey = e => {
    if(e.key==='Escape'){ closeNav(); return; }
    if(e.key!=='Tab') return;
    const els = [...qa('a[href],button:not([disabled])',nav)];
    if(!els.length){ e.preventDefault(); return; }
    if(e.shiftKey && document.activeElement===els[0]){ e.preventDefault(); els.at(-1).focus(); }
    else if(!e.shiftKey && document.activeElement===els.at(-1)){ e.preventDefault(); els[0].focus(); }
  };
  ham.addEventListener('click', openNav);
  q('.mob-nav__bg', nav)?.addEventListener('click', closeNav);
  q('.mob-nav__close', nav)?.addEventListener('click', closeNav);
}

/* ── DESKTOP DROPDOWNS ─────────────────────────────────── */
qa('.nav-dd-wrap').forEach(wrap => {
  const btn = q('.nav-btn', wrap);
  const dd  = q('.nav-dd', wrap);
  if(!btn||!dd) return;
  btn.addEventListener('click', e => {
    e.stopPropagation();
    const open = wrap.classList.toggle('open');
    btn.ariaExpanded = open;
    if(open) q('a',dd)?.focus();
  });
  btn.addEventListener('keydown', e => {
    if(e.key==='Escape'){ wrap.classList.remove('open'); btn.ariaExpanded='false'; btn.focus(); }
  });
});
document.addEventListener('click', () => qa('.nav-dd-wrap.open').forEach(w=>{ w.classList.remove('open'); q('.nav-btn',w).ariaExpanded='false'; }));

/* ── PRODUCT GALLERY ───────────────────────────────────── */
const mainImg = q('#prod-main-img');
if(mainImg){
  qa('.thumb').forEach(t => {
    const activate = () => {
      mainImg.style.opacity='0';
      setTimeout(()=>{ mainImg.src=t.dataset.src; if(t.dataset.srcset) mainImg.srcset=t.dataset.srcset; mainImg.alt=t.dataset.alt||''; mainImg.style.opacity='1'; },150);
      qa('.thumb').forEach(x=>x.classList.remove('on'));
      t.classList.add('on');
    };
    t.addEventListener('click', activate);
    t.addEventListener('keydown', e=>{ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); activate(); }});
  });
}

/* ── QUANTITY BUTTONS ──────────────────────────────────── */
document.addEventListener('click', e => {
  const btn = e.target.closest('.qty__btn');
  if(!btn) return;
  const inp = q('.qty__inp', btn.closest('.qty'));
  if(!inp) return;
  const step = btn.dataset.action==='increase' ? 1 : -1;
  inp.value = Math.max(+(inp.min)||0, (parseInt(inp.value)||1) + step);
  inp.dispatchEvent(new Event('change',{bubbles:true}));
});

/* ── WISHLIST ───────────────────────────────────────────── */
let wl = {};
try{ wl = JSON.parse(sessionStorage.getItem('dh_wl')||'{}'); }catch{}
const syncWish = btn => {
  const on = !!wl[btn.dataset.productId];
  btn.classList.toggle('on', on);
  btn.ariaPressed = on;
  const path = btn.querySelector('path');
  if(path){ path.setAttribute('fill', on?'#E53935':'none'); path.setAttribute('stroke', on?'#E53935':'currentColor'); }
};
qa('.wish-btn').forEach(syncWish);
document.addEventListener('click', e => {
  const btn = e.target.closest('.wish-btn');
  if(!btn) return;
  const id = btn.dataset.productId; if(!id) return;
  wl[id] ? delete wl[id] : (wl[id]=1);
  try{ sessionStorage.setItem('dh_wl', JSON.stringify(wl)); }catch{}
  qa(`.wish-btn[data-product-id="${id}"]`).forEach(syncWish);
});

/* ── VARIANT SELECTORS ─────────────────────────────────── */
const pForm = q('[data-product-form]');
if(pForm){
  const vidInp = q('#prod-variant-id', pForm);
  let variants = [];
  try{ variants = JSON.parse(q('[data-product-json]')?.textContent||'{}').variants||[]; }catch{}

  document.addEventListener('click', e => {
    const btn = e.target.closest('.opt-pill, .col-swatch');
    if(!btn||!pForm.contains(btn)) return;
    const pos = btn.dataset.optionPosition, val = btn.dataset.optionValue;
    qa(`[data-option-position="${pos}"]`, pForm).forEach(b=>{ b.classList.remove('on'); b.ariaPressed='false'; });
    btn.classList.add('on'); btn.ariaPressed='true';
    const lbl = q(`#opt-sel-${pos}`, pForm); if(lbl) lbl.textContent = val;
    if(!variants.length) return;
    const sel = {};
    qa('.prod-opt', pForm).forEach(o=>{ const p=o.dataset.optionPosition, s=q('.on[data-option-position="'+p+'"]',pForm); if(s) sel[p]=s.dataset.optionValue; });
    const match = variants.find(v=>Object.keys(sel).every(p=>v['option'+p]===sel[p]));
    if(!match) return;
    if(vidInp) vidInp.value = match.id;
    const prEl = q('#prod-price');
    if(prEl && match.price!==undefined){
      const fmt = new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',minimumFractionDigits:2});
      const p = fmt.format(match.price/100);
      prEl.innerHTML = `<div class="price"><span class="price__r" aria-label="Price: ${p}">${p}</span></div>`;
    }
    const atc = q('[name="add"]', pForm);
    if(atc){ atc.disabled=!match.available; atc.ariaDisabled=!match.available; q('span',atc).textContent=match.available?'Add to Cart':'Sold Out'; }
  });
}

/* ── QUICK ATC (single-variant cards) ─────────────────── */
const refreshBadge = () =>
  fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}})
    .then(r=>r.json())
    .then(c=>{ qa('[data-cart-badge]').forEach(b=>{ b.textContent=c.item_count; b.hidden=c.item_count===0; }); })
    .catch(()=>{});

document.addEventListener('click', e => {
  const btn = e.target.closest('.pcard__atc');
  if(!btn||btn.disabled) return;
  const vid = btn.dataset.variantId; if(!vid) return;
  btn.disabled=true; const orig=btn.textContent; btn.textContent='Adding…';
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({id:vid,quantity:1})})
    .then(r=>r.json())
    .then(()=>{ btn.textContent='Added ✓'; refreshBadge(); setTimeout(()=>{ btn.textContent=orig; btn.disabled=false; },1500); })
    .catch(()=>{ btn.textContent='Error'; btn.disabled=false; });
});

/* ── COLLECTION SORT ────────────────────────────────────── */
q('[data-sort]')?.addEventListener('change', function(){
  const u = new URL(location.href); u.searchParams.set('sort_by',this.value); location.href=u;
});

/* ── SCROLL-TO-TOP ──────────────────────────────────────── */
const stb = q('#scroll-top');
if(stb){
  window.addEventListener('scroll',()=>{ stb.hidden=scrollY<400; },{passive:true});
  stb.addEventListener('click',()=>scrollTo({top:0,behavior:'smooth'}));
}

/* ── PREFERS REDUCED MOTION ─────────────────────────────── */
if(matchMedia('(prefers-reduced-motion:reduce)').matches){
  document.documentElement.style.setProperty('--t','0s');
  document.documentElement.style.setProperty('--ts','0s');
}

})();
